import React from 'react';
import ImagemHiper from 'assets/img/icones/icon-hiper.png';

const LogoHiper = props => {
  return (<img src={ImagemHiper} width="100" heigth="56" alt="Hiper" style={{marginLeft: '15px'}} />)
};
export default LogoHiper;